import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import {
  PlusCircle,
  RotateCcw,
  ChevronUp,
  Calendar,
} from "feather-icons-react/build/IconComponents";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Table from "../../../../core/pagination/datatable";
import {
  getStockByBranch,
  deleteStock,
  getStockTransferByBranch,
  deleteStockTransfer,
} from "../../../../services/StockApiServices";
import { OverlayTrigger, TabPane, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setheadertoggle } from "../../../../redux/toggle";
import dayjs from "dayjs";
import { renderTooltip } from "../../../../redux/helper";
import { getJSON } from "jquery";
import { InvStockAdjustment } from "../../../../core/json/invStockAdjust";
import StockAdjustmentModal from "../../../../components/transactions/modal/StockAdjustmentModal";
import { DatePicker, Tabs } from "antd";
import {
  printReport,
  exportExcel,
  exportPDF,
} from "../../../../core/utils/reportUtils";
import StockTransferModal from "../../../../components/transactions/modal/StockTransferModal";
import { InvStockTransfer } from "../../../../core/json/InvStockTransfer";

const StockTransferReport = () => {
  const [searchText, setSearchText] = useState("");
  const [updateData, setUpdateData] = useState([]);
  const [modalMode, setModalMode] = useState("add");
  const [modalOpen, setModalOpen] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [activeTab, setActiveTab] = useState("1");

  const [stockList, setStockList] = useState([]);
  const [stockData, setStockData] = useState([]);
  const [filteredStockList, setFilteredStockList] = useState([]);
  const [detailedData, setDetailedData] = useState([]);
  const [filDetailedData, setFilDetailedData] = useState([]);

  const { togglehead } = useSelector((state) => state.headerToggle);

  const { branch } = useSelector((state) => state.branchlist);
  const { userId } = useSelector((state) => state.userauth);

  const dispatch = useDispatch();
  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };

  useEffect(() => {
    handlestockData();
  }, [branch]);

  const handleFromDateChange = (date) => {
    setFromDate(date);
    setToDate(null);
    console.log(date, "from date");
  };

  const handleToDateChange = (date) => {
    setToDate(date);
    console.log(date, "to date");
  };

const getActiveTabData = () => {
  const fieldMapping = {};

  detailedColumns.forEach((col) => {
    fieldMapping[col.title] = col.dataIndex;
  });

  return {
    data: filDetailedData,
    columns: detailedColumns,
    Rname: "Stock Transfer Report",
    fieldMapping,
  };
};
  function handleReset() {
    setFromDate(null);
    setToDate(null);
    setSearchText("");
    handlestockData();
  }
  const modifiedDetData = (data) => {
    return data?.invStockTransferDetails?.map((item, index) => {
      return {
        key: index,
        date: data?.date,
        no: data?.invoiceNo,
        tobranch: data?.toBranch?.name,
        product: item?.product?.name,
        unit: item?.unit?.name,
        batch: item?.batch,
        quantity: item?.quantity,
      };
    });
  };
  const handlestockData = async () => {
    try {
      const response = await getStockTransferByBranch(branch);
      const stockData = Array.isArray(response) ? response : [];
      setStockList(stockData);

      const modifiedData = stockData?.map((entry, index) => {
        return {
          key: index,
          date: entry?.date,
          no: entry?.invoiceNo || 0,
          branch: branch,
          remarks: entry?.remarks || "",
          tobranch: entry?.toBranch?.name || "",
          guid: entry?.guid,
        };
      });

      const modifiedDetailData = stockData.flatMap((stockItem) =>
        modifiedDetData(stockItem)
      );
      setFilDetailedData(modifiedDetailData);
      setDetailedData(modifiedDetailData);
      setStockData(modifiedData);
      setFilteredStockList(modifiedData);
      console.log(modifiedData, "modifiedData");
    } catch (error) {
      console.error(
        "Failed to fetch Stock adjustments",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleSearch = (e) => {
    setSearchText(e?.target?.value);
  };


  const detailedColumns = [
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => (dayjs(a.date).isAfter(dayjs(b.date)) ? 1 : -1),
      render: (date) => dayjs(date).format("DD-MM-YY"),
    },

    {
      title: "Entry No",
      dataIndex: "no",
      sorter: (a, b) => a.no - b.no,
    },
    {
      title: "To Branch",
      dataIndex: "tobranch",
      sorter: (a, b) => a.tobranch.localeCompare(b.tobranch),
    },
    {
      title: "Product",
      dataIndex: "product",
      sorter: (a, b) => a.product.localeCompare(b.product),
    },
    {
      title: "Unit",
      dataIndex: "unit",
      sorter: (a, b) => a.unit.localeCompare(b.unit),
    },
    {
      title: "Batch",
      dataIndex: "batch",
      sorter: (a, b) => a.batch?.localeCompare(b?.batch),
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      sorter: (a, b) => a.quantity - b.quantity,
    },
  ];

  const MySwal = withReactContent(Swal);


  function getStockTrnByGuid(guid) {
    console.log(guid, "--------------guid");
    console.log(stockList, "--------------stockList");
    const filteredStock = stockList?.filter(
      (stockTrn) => stockTrn.guid === guid
    );

    return filteredStock[0];
  }
  // Function to format the date into day, month, and year components
  function formatDate(dateInput) {
    const dateObj = new Date(dateInput);

    const day = Number(dateObj.getDate());
    const month = Number(dateObj.getMonth() + 1);
    const year = Number(dateObj.getFullYear() % 100); // Last two digits of year

    return { day, month, year };
  }

  // Function to compare two dates (returns true if date1 >= date2)
  function compareDates(fromDate, toDate) {
    const {
      day: fromDay,
      month: fromMonth,
      year: fromYear,
    } = formatDate(fromDate);
    const { day: toDay, month: toMonth, year: toYear } = formatDate(toDate);

    if (fromYear > toYear) return true;
    if (fromYear === toYear && fromMonth > toMonth) return true;
    if (fromYear === toYear && fromMonth === toMonth && fromDay >= toDay)
      return true;

    return false;
  }
  // const [sortedSumData, setsortedSumData] = useState([]);
  // useEffect(() => {
  //   const sortedData = filteredStockList.sort(
  //     (a, b) => new Date(a.updatedDate) - new Date(b.updatedDate)
  //   );
  //   setsortedSumData(sortedData);
  // }, [filteredData]);

  function handleFilter() {
    const filteredData = stockData.filter((entry) => {
      const fromDateMatch = !fromDate || compareDates(entry.date, fromDate);
      const toDateMatch = !toDate || compareDates(toDate, entry.date);
      console.log(searchText, "searchText");

      const searchTextMatch =
        entry?.date?.toString().includes(searchText?.toLowerCase()) ||
        entry?.no?.toString().includes(searchText?.toLowerCase()) ||
        entry?.tobranch?.toLowerCase().includes(searchText) ||
        entry?.remarks?.toLowerCase().includes(searchText);

      return fromDateMatch && toDateMatch && searchTextMatch;
    });

    console.log("filteredData", filteredData);
    setFilteredStockList(filteredData);
    // const modifiedDetailData = stockList.flatMap((stockItem) =>
    //   modifiedDetData(stockItem)
    // );
    // setFilDetailedData(modifiedDetData);
    const filteredDetData = detailedData.filter((entry) => {
      console.log("entry", entry);
      const fromDateMatch = !fromDate || compareDates(entry.date, fromDate);
      const toDateMatch = !toDate || compareDates(toDate, entry.date);

      const searchTextMatch =
        entry?.date?.toString().includes(searchText?.toLowerCase()) ||
        entry?.no?.toString().includes(searchText?.toLowerCase()) ||
        entry?.tobranch?.toLowerCase().includes(searchText) ||
        entry?.product?.toLowerCase().includes(searchText?.toLowerCase());
      entry?.quantity?.toString().includes(searchText?.toLowerCase());
      entry?.unit?.toLowerCase().includes(searchText?.toLowerCase());
      entry?.batch?.toLowerCase().includes(searchText?.toLowerCase());

      return fromDateMatch && toDateMatch && searchTextMatch;
    });
    setFilDetailedData(filteredDetData);
  }

  const handleTabChange = (key) => {
    console.log("Active Tab:", key);
    setActiveTab(key);
  };

  return (
    <div className="ax-master ax-report">
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Stock Transfer Report</h4>
                <h6>Manage Stock Transfer Reports here</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                  <Link
                    onClick={() => exportPDF(getActiveTabData, "Stocktransfer")}
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Excel")}
                >
                  <Link
                    onClick={() =>
                      exportExcel(getActiveTabData, "Stocktransfer")
                    }
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Print")}
                >
                  <Link
                    onClick={() =>
                      printReport(getActiveTabData, "Stocktransfer")
                    }
                  >
                    <i data-feather="printer" className="feather-printer" />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Refresh")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    onClick={() => handlestockData()}
                  >
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Collapse")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={togglehead ? "active" : ""}
                    onClick={handletogglehead}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>

          </div>

          <div className="card table-list-card">
            <div className="card-body">
               <div className="table-top mb-2">
               <div className="search-set">
        <div className="search-input">
          <div id="DataTables_Table_0_filter" className="dataTables_filter">
            <div className="input-group input-group-sm">
              <span className="input-group-text bg-white border-end-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-search"
                >
                  <circle cx="11" cy="11" r="8" />
                  <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
              </span>
              <input
                type="search"
                className="form-control border-start-0"
                placeholder="Search"
                value={searchText}
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
      </div>
              </div>
              {/* </div> */}
              <div className="table-responsive">
                    <Table
                      columns={detailedColumns}
                      dataSource={filDetailedData}
                    />
              </div>
            </div>
          </div>
        </div>
      </div>

      {modalOpen && (
        <StockTransferModal
          mode={modalMode}
          data={modalMode === "edit" ? updateData : {}}
          handleClose={() => setModalOpen(false)}
          handleRefresh={() => {
            handlestockData();
            setSearchText("");
          }}
        />
      )}
    </div>
  );
};

export default StockTransferReport;
